module.exports = __webpack_public_path__ + "static/Mixed-Pitted-Marinated-Olives-b4424bef625373b0a020b5127ae614cd.png";